
import restClient from 'restClient'

const restClientInstance = restClient(window.API_ROOT + '/api')

export interface TariffRecommendationRequest {
  design_data?: any
  tariff_codes?: string[]
  filters?: {
    country_iso2?: string 
    state?: string
    zip?: string
    sector?: number
    utility_id?: number  
  }
  system_uuid?: string
  battery_control_scheme_overrides?: Record<string, string>
  default_battery_control_scheme?: string
  tariff_classifications?: Record<string, 'battery' | 'solar'>
  full_calcs?: boolean  // If true, runs full multi-year calculations; if false, first year only (default)
  unsaved_tariff_current_code?: string  // Tariff code for unsaved current tariff
  unsaved_tariff_proposed_code?: string  // Tariff code for unsaved proposed tariff
}

export interface TariffRecommendation {
  tariff_id: number
  tariff_code: string
  tariff_name: string
  yearly_savings: number
  yearly_savings_breakdown: number[]
  battery_control_scheme?: string | null
  error?: string | null
}

export interface TariffRecommendationResponse {
  recommendations: TariffRecommendation[]
  baseline_tariff_id: number | null
  baseline_battery_control_scheme: string | null
  baseline_tariff_savings: number | null
  total_tariffs_evaluated: number
  errors?: Array<{ tariff_id: number; tariff_code: string; error: string }>
}


export const getTariffRecommendations = async (
  orgId: number,
  projectId: number | string | null,
  request: TariffRecommendationRequest
): Promise<TariffRecommendationResponse> => {
  const url = projectId
    ? `orgs/${orgId}/projects/${projectId}/tariff_recommendations/`
    : `orgs/${orgId}/tariff_recommendations/`

  const response = await restClientInstance('CUSTOM_POST', 'custom', {
    url,
    data: request,
  })

  return response.data
}
